import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

/** Optional clinical guidance stays available without lengthening the answer labels. */
export function QuestionGuidance({
  help,
  options,
}: {
  help?: string;
  options?: readonly { label: string; detail?: string }[];
}) {
  const details = options?.filter((option) => option.detail);
  if (!help && !details?.length) return null;
  return (
    <Collapsible className="mt-2 text-sm">
      <CollapsibleTrigger render={<Button type="button" variant="ghost" size="sm" />}>
        {details?.length ? "Show guidance and option details" : "Show help"}
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-2 pt-2 text-muted-foreground">
        {help && <p className="whitespace-pre-wrap">{help}</p>}
        {details?.map((option, index) => (
          <p key={`${index}-${option.label}`} className="whitespace-pre-wrap">
            <span className="font-medium text-foreground">{option.label}: </span>
            {option.detail}
          </p>
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
}
